<template>
  <v-row align="center" justify="center" class="h-100">
    <AppLoader />
  </v-row>
</template>

<script>
import * as Sentry from '@sentry/vue'

import AppLoader from '@/common/AppLoader.vue'
import { IMANAGE_REFUSAL_USER_SETTINGS_KEY } from '@/common/imanage/IManageAuthDialog.vue'
import { getUserId, removeUserId } from '@/common/utils/localUserId'
import { getSignInRoute } from '@/common/utils/login'
import { SUBDOMAIN_COOKIE_KEY, getRootDomainFromUrl } from '@/common/utils/url'
import { removeUserSetting } from '@/common/utils/userSettings'
import loginService from '@/services/login.service'
import { STORE_PERSIST_KEY } from '@/store'

export default {
  name: 'Logout',
  components: { AppLoader },
  props: {
    isLogOut: {
      type: [Boolean, String],
    },
    isVoluntaryLogOut: {
      type: [Boolean, String],
    },
    // Overrides the basic functionality that redirects to the login
    redirectPath: {
      type: String,
      required: false,
    },
    // Full path of the route we want to come back to
    returnRoute: {
      type: String,
      default: '',
    },
  },
  async created () {
    const clientAppUrl = import.meta.env.VUE_APP_CLIENT_URL
    const cookieDomain = getRootDomainFromUrl(clientAppUrl)
    const subdomain = this.$cookies.get(SUBDOMAIN_COOKIE_KEY)
    const userId = getUserId();

    this.$cookies.remove(SUBDOMAIN_COOKIE_KEY, null, cookieDomain)

    try {
      await loginService.logout()
    } catch {
      console.error('Backend log out failed')
    }

    if (this.isVoluntaryLogOut) {
      removeUserSetting(userId, IMANAGE_REFUSAL_USER_SETTINGS_KEY);
    }
    
    removeUserId()
    try {
      if (window.zE) {
        window.zE('messenger', 'logoutUser')
      }
    } catch {
      console.error('zendesk log out failed')
    }
    try {
      Sentry.setUser(null)
    } catch {
      console.error('Could not unset Sentry user ID')
    }
    // Done in an immediately queued timer so that the persist already handled the changes it needed to do
    // And we can then remove it entirely
    setTimeout(() => {
      localStorage.removeItem(STORE_PERSIST_KEY)
      let host = window.location.host
      // If we logged from a subdomain, replace the first part of the host (the subdomain part)
      // With the subdomain so that we're back where we started
      if (subdomain) {
        host = host.replace(host.split('.')[0], subdomain)
      }
      const ROUTE_PATH_PREPEND_URL = window.location.protocol + '//' + host

      if (this.redirectPath) {
        window.location.replace(
          ROUTE_PATH_PREPEND_URL +
          this.redirectPath,
        )
        return
      }

      // Force refresh into sign in. Every state is reset.
      // Forward query params
      const queryParamsToForward = {
        isLogOut: this.isLogOut,
        isVoluntaryLogOut: this.isVoluntaryLogOut,
      }

      if (this.returnRoute) {
        queryParamsToForward.returnRoute = this.returnRoute || '/'
      }

      window.location.replace(
        ROUTE_PATH_PREPEND_URL +
        this.$router.resolve(getSignInRoute({}, queryParamsToForward)).href,
      )
    }, 0)
  },
}
</script>
